import { Button } from 'antd';
import 'antd/es/button/style/index';
import './index.less';

export default Button;
